import React from 'react';
import { ILocationMessage } from '../../../client/message/types';
import { Box, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useTranslation } from '@fanfanlo';


interface LocationMessageProps {
  message: ILocationMessage;
  className?: string;
}

export const LocationMessage = ({ message, className = '' }: LocationMessageProps) => {
  const { t } = useTranslation('homepage/im/components/messages/location/content');
  // 从 geo_uri 中解析经纬度
  const geoUri = message.content.geo_uri;
  const [_, coordinates] = geoUri.split(':');
  const [latitude, longitude] = coordinates.split(',').map(Number);
  
  // 构建静态地图 URL（使用百度地图）
  const mapUrl = `https://api.map.baidu.com/staticimage/v2?ak=${process.env.REACT_APP_BAIDU_MAP_KEY || 'MmweUMZxcXOThZUaBuQ2rtKwLNHf1Hix'}&center=${longitude},${latitude}&zoom=12&width=300&height=200&markers=${longitude},${latitude}&markerStyles=m,B,0`;
  
  // 处理点击事件，打开交互式地图
  const [open, setOpen] = React.useState(false);
  const handleOpenMap = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  
  return (
    <Box className={`location-message ${className}`}>
      <Box className="map-container" mb={1}>
        <img 
          src={mapUrl} 
          alt={message.content.info?.title || t('LocationMessage.title')} 
          onClick={handleOpenMap}
          style={{ cursor: 'pointer' }}
        />
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="textSecondary">
          {message.content.info?.title || t('LocationMessage.title')}
        </Typography>
        <Button 
          variant="text" 
          size="small" 
          onClick={handleOpenMap}
        >
          {t('LocationMessage.viewMap')}
        </Button>
      </Box>
      {open && (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
          <DialogTitle>{message.content.info?.title || t('LocationMessage.title')}</DialogTitle>
          <DialogContent>
            <InteractiveLocationMap message={message} />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              {t('LocationMessage.close')}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

// 在需要显示交互式地图的地方使用
const InteractiveLocationMap = React.forwardRef(({ message }: { message: ILocationMessage }, ref) => {
  const [_, coordinates] = message.content.geo_uri.split(':');
  const [latitude, longitude] = coordinates.split(',').map(Number);
  
  return (
    <Box sx={{
      width: '100%',
      height: 400,
      minHeight: 300,
      position: 'relative'
    }}>
     
    </Box>
  );
});

